(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-notification"]) return;
  try {
    
  if (!customElements.get('cart-notification')) {
    customElements.define(
      'cart-notification',
      class CartNotification extends HTMLElement {
        connectedCallback() {
          this.panel = this.querySelector('[data-cart-notification-panel]');
          this.product = this.querySelector('[data-cart-notification-product]');
          this.viewCart = this.querySelector('[data-cart-notification-view]');

          this.onAdded = this.onAdded.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);

          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-cart-notification-close]')) this.close();
          });

          document.addEventListener('cart:added', this.onAdded);
        }

        disconnectedCallback() {
          document.removeEventListener('cart:added', this.onAdded);
          this.stopListening();
        }

        onAdded(event) {
          const { key, html, trigger } = event.detail || {};
          if (!html) return;

          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const line = parsed.querySelector(`[data-cart-notification-item="${key}"]`);

          // A key that matches nothing means the render raced a cart change
          // elsewhere. The add itself still succeeded, so confirm it without a
          // line rather than leaving the shopper with no feedback at all.
          this.product.replaceChildren(...(line ? [line] : []));
          this.updateCount(parsed.querySelector('[data-cart-item-count]')?.dataset.cartItemCount);
          this.open(trigger);
        }

        /**
         * `/cart/add.js` answers with the added line, not with cart totals, so
         * the new item count rides along on the rendered section instead. Dawn
         * gets it from separate `cart-notification-button` and
         * `cart-icon-bubble` section renders; one data attribute does the same
         * job for both the button label and the header badge.
         */
        updateCount(count) {
          if (count === undefined) return;
          const total = Number(count);

          const template = this.viewCart?.dataset.labelTemplate;
          if (template) this.viewCart.textContent = template.replace('[count]', total);

          document.querySelectorAll('[data-cart-count]').forEach((badge) => {
            badge.textContent = total;
            badge.classList.toggle('header__cart-count--empty', total === 0);
          });
        }

        open(trigger) {
          // Only remember the opener the first time, so adding a second item
          // while the popup is up doesn't move where focus lands on close.
          if (!this.classList.contains('cart-notification--active')) {
            this.opener = trigger || document.activeElement;
          }

          this.classList.add('cart-notification--active');
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeydown);

          // The panel is only focusable once the class has flipped it back to
          // `visibility: visible`, hence the frame's delay. `preventScroll`
          // keeps the page where the shopper left it.
          requestAnimationFrame(() => this.panel.focus({ preventScroll: true }));
        }

        close() {
          if (!this.classList.contains('cart-notification--active')) return;

          this.classList.remove('cart-notification--active');
          this.stopListening();

          if (this.opener?.isConnected) this.opener.focus();
          this.opener = null;
        }

        stopListening() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeydown);
        }

        onDocumentClick(event) {
          if (!this.contains(event.target)) this.close();
        }

        onKeydown(event) {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          this.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-page-form]').forEach((form) => {
    let changeTimer;

    form.addEventListener('change', (event) => {
      if (!event.target.closest('.quantity__input')) return;
      clearTimeout(changeTimer);
      changeTimer = setTimeout(() => form.requestSubmit(), 300);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-band"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-copy-email]');
    if (!chip || !navigator.clipboard) return;

    event.preventDefault();
    navigator.clipboard.writeText(chip.dataset.copyEmail).then(() => {
      const label = chip.querySelector('[data-copy-email-label]');
      if (!label || chip.dataset.copied) return;
      chip.dataset.copied = 'true';
      const original = label.textContent;
      label.textContent = chip.dataset.copiedText || 'Copied!';
      setTimeout(() => {
        label.textContent = original;
        delete chip.dataset.copied;
      }, 2000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Draws the sticky header's hairline once the page has scrolled away from the
   * top. Guarded by a flag on the wrapper so a re-render in the theme editor
   * can't stack up a second scroll listener.
   */
  (() => {
    const init = () => {
      const wrapper = document.querySelector('.shopify-section-group-header-group');
      if (!wrapper || wrapper.dataset.stuckWatch) return;
      wrapper.dataset.stuckWatch = 'true';

      const update = () => {
        wrapper.classList.toggle('shopify-section-group-header-group--stuck', window.scrollY > 0);
      };

      update();
      window.addEventListener('scroll', update, { passive: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  if (!customElements.get('header-drawer')) {
    customElements.define(
      'header-drawer',
      class HeaderDrawer extends HTMLElement {
        static focusableSelector =
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), input:not([type=hidden]):enabled, select:enabled, textarea:enabled";

        connectedCallback() {
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');
          this.drawer = this.querySelector('.header__drawer');
          if (!this.details || !this.summary || !this.drawer) return;

          this.onToggle = this.onToggle.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onFocusIn = this.onFocusIn.bind(this);

          this.details.addEventListener('toggle', this.onToggle);
          this.addEventListener('keydown', this.onKeydown);
        }

        disconnectedCallback() {
          this.stopTrapping();
        }

        get isOpen() {
          return this.details.open;
        }

        onToggle() {
          this.summary.setAttribute('aria-expanded', String(this.isOpen));

          if (this.isOpen) {
            document.addEventListener('focusin', this.onFocusIn);
            document.addEventListener('keydown', this.onKeydown);
            this.focusables()[1]?.focus();
          } else {
            this.stopTrapping();
          }
        }

        stopTrapping() {
          document.removeEventListener('focusin', this.onFocusIn);
          document.removeEventListener('keydown', this.onKeydown);
        }

        focusables() {
          const inDrawer = Array.from(this.drawer.querySelectorAll(HeaderDrawer.focusableSelector)).filter(
            (element) => element.offsetParent !== null
          );
          return [this.summary, ...inDrawer];
        }

        onFocusIn(event) {
          if (!this.isOpen) return;
          if (this.contains(event.target)) return;
          event.preventDefault();
          this.focusables()[0]?.focus();
        }

        onKeydown(event) {
          if (!this.isOpen) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }

          if (event.key !== 'Tab') return;

          const focusables = this.focusables();
          if (focusables.length === 0) return;
          const first = focusables[0];
          const last = focusables[focusables.length - 1];

          if (event.shiftKey && event.target === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && event.target === last) {
            event.preventDefault();
            first.focus();
          }
        }

        close() {
          this.details.open = false;
          this.summary.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-details')) {
    customElements.define(
      'product-details',
      class ProductDetails extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-product-form]');
          this.abortController = new AbortController();
          this.addEventListener('click', this.onMediaClick.bind(this));
          this.querySelector('variant-selects')?.addEventListener('change', this.onVariantChange.bind(this));
          this.form?.addEventListener('submit', this.onSubmit.bind(this));
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        onMediaClick(event) {
          const thumb = event.target.closest('[data-media-thumb]');
          if (!thumb) return;
          this.activateMedia(thumb.dataset.mediaThumb);
        }

        activateMedia(mediaId) {
          this.querySelectorAll('video').forEach((video) => video.pause());
          this.querySelectorAll('[data-media-frame]').forEach((frame) => {
            const isActive = frame.dataset.mediaFrame === String(mediaId);
            frame.hidden = !isActive;
            frame.classList.toggle('is-active', isActive);
          });
          this.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
            const isActive = thumb.dataset.mediaThumb === String(mediaId);
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', String(isActive));
          });
        }

        onVariantChange(event) {
          const target = event.target;
          if (!target.matches('[data-option-value-id]')) return;

          const selectedOptionValues = Array.from(
            this.querySelectorAll('variant-selects input:checked')
          ).map((input) => input.dataset.optionValueId);
          const productUrl = target.dataset.productUrl || this.dataset.url;
          const requestUrl = new URL(productUrl, window.location.origin);
          requestUrl.searchParams.set('section_id', this.dataset.sectionId);
          requestUrl.searchParams.set('option_values', selectedOptionValues.join(','));

          this.abortController.abort();
          this.abortController = new AbortController();
          this.setAttribute('aria-busy', 'true');

          fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const replacement = html.querySelector('product-details');
              if (!replacement) throw new Error('Product section was not returned');

              const variantId = replacement.querySelector('[data-variant-id]')?.value;
              const browserUrl = new URL(replacement.dataset.url, window.location.origin);
              if (variantId) browserUrl.searchParams.set('variant', variantId);
              window.history.replaceState({}, '', `${browserUrl.pathname}${browserUrl.search}`);

              this.replaceWith(replacement);
              window.Shopify?.PaymentButton?.init();
              window.ProductModel?.loadShopifyXR?.();
              document.getElementById(target.id)?.focus();
            })
            .catch((error) => {
              if (error.name === 'AbortError') return;
              this.removeAttribute('aria-busy');
              const errorMessage = this.querySelector('[data-product-error]');
              if (errorMessage) errorMessage.hidden = false;
            });
        }

        onSubmit(event) {
          event.preventDefault();
          const submitButton = this.form.querySelector('[data-add-to-cart]');
          const errorMessage = this.form.querySelector('[data-product-error]');
          errorMessage.hidden = true;
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');

          const body = new FormData(this.form);
          body.append('sections', 'cart-notification-product');
          body.append('sections_url', window.location.pathname);

          fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body })
            .then((response) => response.json().then((json) => ({ ok: response.ok, json })))
            .then(({ ok, json }) => {
              if (!ok) throw new Error(json.description || 'error');
              document.dispatchEvent(
                new CustomEvent('cart:added', {
                  detail: {
                    key: json.key,
                    html: json.sections?.['cart-notification-product'],
                    // The popup returns focus here when it closes. It has to be
                    // passed explicitly: this button is still disabled at this
                    // point, so focus has already fallen back to <body>.
                    trigger: submitButton,
                  },
                })
              );
            })
            .catch((error) => {
              const message = errorMessage.querySelector('span');
              if (error.message !== 'error') message.textContent = error.message;
              errorMessage.hidden = false;
            })
            .finally(() => {
              submitButton.removeAttribute('aria-busy');
              submitButton.disabled = this.form.querySelector('[data-variant-id]').disabled;
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
